import React from 'react';

import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';

import Button from 'components/Button';
import globalMessages from 'translations/messages/global-messages';

const styles = theme => ({
  wrapper: {
    position: 'absolute',
    bottom: theme.spacing(8),
    right: 90,
    zIndex: 11,
  },
});

const SaveButton = ({ onClick, disabled, intl, classes }) => {
  const onButtonClick = event => {
    event.stopPropagation();
    event.preventDefault();
    onClick();
  };
  return (
    <div className={classes.wrapper}>
      <Button disabled={disabled} onClick={onButtonClick} size="small">
        {intl.formatMessage(globalMessages.save_and_update)}
      </Button>
    </div>
  );
};

SaveButton.propTypes = {
  intl: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
  classes: PropTypes.object,
  onClick: PropTypes.func.isRequired,
};

export default compose(withStyles(styles, { withTheme: true }), injectIntl)(SaveButton);
